import SlabWorkspace from "../core/slab/slabWorkspace";
import workspace from "../core/workspace";
import {SHAPE_PART_ID} from "../../../constants";
import SQFTShapeOffset from "../core/shapes/sqftShapeOffset";
import sqftShape from "../core/shapes/sqftShape";
import createEventManager from "./subscriptionEventManager";

const eventManager = createEventManager();

const sqftSlabManager = {
  ...eventManager,

  centerButton: {
    width: 10,
    height: 9,
  },

  importSlabBacksplashes: (values) => {
    SlabWorkspace.slabAdditionalShapes.resetBacksplashes();
    SlabWorkspace.slabAdditionalShapes.importData(values);
  },
  removeAllSlabBacksplashes: (values) => {
    SlabWorkspace.slabAdditionalShapes.resetBacksplashes(values);
  },
  deleteSlabBacksplashByLine: (line) => {
     SlabWorkspace.slabAdditionalShapes.removeActiveBacksplashByLine(line);
  },
  getSlabPlaceHolderShapes: () => {
     return workspace.getShapes().filter(shp => shp.partId === SHAPE_PART_ID.slabPlaceHolder);
  },
  deleteShapeOffset: () => {
    if (SlabWorkspace.shapeOffset) {
      SlabWorkspace.shapeOffset.delete()
    }
    SlabWorkspace.shapeOffset = null
  },
  hideShapeOffset: () => {
     if (SlabWorkspace.shapeOffset) {
       SlabWorkspace.shapeOffset.deregisterEvents();
     }
  },
  reInitShapeOffset: () => {
    if (SlabWorkspace.shapeOffset) {
      SlabWorkspace.shapeOffset.reInitEvents();
    }
  },
  initShapeOffset: function (shape) {
    const shapes = workspace.getShapes();
    if (shape instanceof sqftShape) {
      if (SlabWorkspace.shapeOffset === null) {
        SlabWorkspace.shapeOffset = new SQFTShapeOffset(shapes[0]);
        SlabWorkspace.shapeOffset.init();
        SlabWorkspace.shapeOffset.setParent(shape);
        this.emit('shapeOffsetChanged', SlabWorkspace.shapeOffset);
      } else {
        SlabWorkspace.shapeOffset.animateShapeTransition(
          shape,
          () => {this.emit('shapeOffsetChanged', SlabWorkspace.shapeOffset)}
        );
      }

    }
  }
}

export default sqftSlabManager
